<template>
  <el-card>
    <el-page-header @back="goBack" :content="'数据集：' + dataset.name || ''" />
    <!-- 表单 -->
    <div class="top">
      <div class="searchForm"></div>
      <div class="right">
        <el-button
          class="float-right"
          type="primary"
          @click="onAdd"
          v-if="isUploadType && jurisdiction.powerElement_agent_create"
        >
          新建文档
        </el-button>
      </div>
    </div>
    <!-- 列表 -->
    <el-table :data="list">
      <el-table-column label="文档名称" prop="name"></el-table-column>
      <el-table-column label="状态" prop="status">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 'pending'" type="info">待处理</el-tag>
          <el-tag v-if="scope.row.status === 'processing'" type="primary">处理中</el-tag>
          <el-tag v-if="scope.row.status === 'completed'" type="success">已完成</el-tag>
          <el-tag v-if="scope.row.status === 'failed'" type="danger">处理失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <template>
            <el-button @click="onShowSegment(scope.row)" type="text" size="small">
              文档分块表
            </el-button>
            <el-button
              v-if="jurisdiction.powerElement_agent_edit"
              @click="onEdit(scope.row)"
              type="text"
              size="small"
            >
              编辑
            </el-button>
            <el-button
              v-if="jurisdiction.powerElement_agent_delete"
              @click="onDelete(scope.row)"
              type="text"
              size="small"
            >
              移除
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    />
    <create-edit-document
      :visible="visible"
      :row="editData"
      :type="openType"
      :is-upload-type="isUploadType"
      @close="visible = false"
      @refresh="getList"
    />
  </el-card>
</template>

<script>
import { mapGetters } from 'vuex';
import CreateEditDocument from '../components/createEditDocument.vue';
export default {
  components: {
    CreateEditDocument,
  },
  data() {
    return {
      payload: {
        limit: 10,
        offset: 0,
      },
      // 表格
      loading: false,
      list: [],
      tagGroupList: [],
      page: 1,
      pageSize: 10,
      total: 0,
      // 弹窗
      visible: false,
      editData: {},
      openType: 'create',
      dataset: {},
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      const jurisdictionArray = [
        'powerElement_agent_create',
        'powerElement_agent_edit',
        'powerElement_agent_delete',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }
      return jurisdictionObj;
    },
    datasetId() {
      return this.$route.query.dataset_id;
    },
    isUploadType() {
      return this.dataset?.data_source_type === 'upload';
    },
  },
  async created() {
    this.getList();
    this.getDataset();
  },
  methods: {
    async getDataset() {
      try {
        this.dataset = {};
        const { dataset } = await this.$request({
          url: this.$api.getAgentDataset,
          data: {
            id: this.$route?.query?.dataset_id,
          },
        });
        this.dataset = dataset;
      } catch (err) {
        console.log(err);
        this.dataset = {};
      }
    },
    async getList() {
      this.loading = true;
      this.payload = {
        ...this.payload,
        limit: this.pageSize,
        offset: (this.page - 1) * this.pageSize,
      };
      try {
        const { documents, total_count: total } = await this.$request({
          url: this.$api.listAgentDocuments,
          data: {
            dataset_id: this.datasetId,
            ...this.payload,
          },
        });
        this.list = documents;
        this.total = parseInt(total);
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.list = [];
        this.loading = false;
      }
    },
    onAdd() {
      this.editData = {};
      this.openType = 'create';
      this.visible = true;
    },
    onEdit(row) {
      this.editData = row;
      this.openType = 'edit';
      this.visible = true;
    },
    async onDelete(row) {
      this.$confirm(`确定移除文档[${row.name}]吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const data = {
          id: row.id,
        };
        await this.$request({
          url: this.$api.deleteAgentDocument,
          data,
        });
        this.$message({
          message: '删除成功',
          type: 'success',
        });
        this.getList();
      });
    },
    // 翻页器
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getList();
    },
    onShowSegment(row) {
      this.$router.push({ name: 'ai-dataset-document-segments', query: { document_id: row.id } });
    },
    goBack() {
      this.$router.history.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/input.scss';
@import '@/styles/element/select.scss';
@import '@/styles/element/button.scss';
@import '@/styles/element/tab.scss';
@import '@/styles/element/table.scss';
@import '@/styles/element/dropdown.scss';
@import '@/styles/element/pagination.scss';
.top {
  display: flex;
  .searchForm {
    flex: 1;
  }
}
.app-select {
  width: 120px;
}
</style>
